module.exports = __webpack_public_path__ + "static/media/ottawa-40.277fdaba.jpg";